import { render, staticRenderFns } from "./HolidaysList.vue?vue&type=template&id=17520f39&scoped=true"
import script from "./HolidaysList.ts?vue&type=script&lang=ts&external"
export * from "./HolidaysList.ts?vue&type=script&lang=ts&external"
import style0 from "./HolidaysList.vue?vue&type=style&index=0&id=17520f39&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17520f39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17520f39')) {
      api.createRecord('17520f39', component.options)
    } else {
      api.reload('17520f39', component.options)
    }
    module.hot.accept("./HolidaysList.vue?vue&type=template&id=17520f39&scoped=true", function () {
      api.rerender('17520f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Holidays/components/HolidaysList/HolidaysList.vue"
export default component.exports